export function date(date) {
    var d = toDate(date)
    
    var weekDays = {}
    weekDays.en = [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
    ]
    weekDays.br = [
        "Domingo",
        "Segunda-feira",
        "Terça-feira",
        "Quarta-feira",
        "Quinta-feira",
        "Sexta-feira",
        "Sábado",
    ]
    
    var months = {}
    months.en = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ]
    
    
    months.br = [
        "Janeiro",
        "Fevereino",
        "Março",
        "Abril",
        "Maio",
        "Junho",
        "Julho",
        "Agosto",
        "Setembro",
        "Outubro",
        "Novembro",
        "Dezembro"
    ]

    
    return {
        'day': (twoDigits = false, language = 'br') => {
            var day = d.getDate()
            var weekDay = weekDays[language][d.getDay()]
            if(twoDigits) {
                return (day < 10) ? '0'+day : day
            }
            return { 
                'int': day,
                'str': weekDay,
                'abbrev': weekDay.slice(0,3)
            }
        },
        'year': () => {
            return d.getFullYear()
        },
        'month': (language = 'en') => {
            var month = d.getMonth()
            var monthName = months[language][month]
            return {
                'int': month,
                'str': monthName,
                'abbrev': monthName.slice(0,3),
            }
        },
        'br': date.split('-').reverse().join('/')
    }
}

export function toDecimal( number ) {
    if( number.indexOf('.') > number.indexOf(',') ) {
        number = number.replace(/,/g, '')
    } else {
        number = number.replace(/\./g, '')
        number = number.replace(/,/g, '.')
    }
    number = number === '' ? 0 : number
    return parseFloat(number)
}

export function numberFormat (number, decimals = 2, dec_point = ',', thousands_sep = '.') {
    // Strip all characters but numerical ones.
    number = (number + '').replace(/[^0-9+\-Ee.]/g, '');
    var n = !isFinite(+number) ? 0 : +number,
        prec = !isFinite(+decimals) ? 0 : Math.abs(decimals),
        sep = (typeof thousands_sep === 'undefined') ? ',' : thousands_sep,
        dec = (typeof dec_point === 'undefined') ? '.' : dec_point,
        s = '',
        toFixedFix = function (n, prec) {
            var k = Math.pow(10, prec);
            return '' + Math.round(n * k) / k;
        };
    // Fix for IE parseFloat(0.55).toFixed(0) = 0;
    s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.');
    if (s[0].length > 3) {
        s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
    }
    if ((s[1] || '').length < prec) {
        s[1] = s[1] || '';
        s[1] += new Array(prec - s[1].length + 1).join('0');
    }
    return s.join(dec);
}

export function dateHour(hour) {
   hour = hour.split(':')
   return hour.map(i => i.length < 2 ? '0'+i : i).join(':')
}

export function timeToDate(unix_timestamp) {
    unix_timestamp = parseInt(unix_timestamp, 10)
    return new Date(unix_timestamp*1000)
}

export function toDate(date) {
    if(!date) return
    if(!date.indexOf) return

    date = date.split(" ")[0]

    if(date.indexOf('/') > -1)
    date = date.split('/').reverse()

    if(date.indexOf('-') > -1)
    date = date.split('-')

    return new Date(date[0], date[1]-1, date[2])
}

export function dateFormat(format, date) {
    if(!(date instanceof Date))
    date = toDate(date)
    
    if(!date) return

    let string = ''
    for (var i = 0; i < format.length; i++) {
        var key = format[i]

        switch (key) {
            case 'd':
                string += (date.getDate() < 10) ? `0${date.getDate()}` : date.getDate()
                break
            case 'm':
                string += (date.getMonth()+1 < 10) ? `0${date.getMonth()+1}` : date.getMonth()+1
                break
            case 'y':
                string += date.getFullYear()
                break
            case 'h':
                string += (date.getHours() < 10) ? `0${date.getHours()}` : date.getHours()
                break
            case 'i':
                string += (date.getMinutes() < 10) ? `0${date.getMinutes()}` : date.getMinutes()
                break
            case 's':
                string += (date.getSeconds() < 10) ? `0${date.getSeconds()}` : date.getSeconds()
                break
            default:
                string += key
                break
        }
    }

    return string
}

export function dateTimeFormat( format, datetime ) {
    const date = new Date(Date.parse(datetime))
    // let year    = date.getFullYear()
    // let mont    = date.getMonth() + 1
    // let day     = date.getDate()
    // let hours   = date.getHours()
    // let minutes = date.getMinutes()
    // let seconds = date.getSeconds()


    let string = ''
    for (var i = 0; i < format.length; i++) {
        var key = format[i]

        switch (key) {
            case 'd':
                string += (date.getDate() < 10) ? `0${date.getDate()}` : date.getDate()
                break
            case 'm':
                string += (date.getMonth()+1 < 10) ? `0${date.getMonth()+1}` : date.getMonth()+1
                break
            case 'y':
                string += date.getFullYear()
                break
            case 'h':
                string += (date.getHours() < 10) ? `0${date.getHours()}` : date.getHours()
                break
            case 'i':
                string += (date.getMinutes() < 10) ? `0${date.getMinutes()}` : date.getMinutes()
                break
            case 's':
                string += (date.getSeconds() < 10) ? `0${date.getSeconds()}` : date.getSeconds()
                break
            default:
                string += key
                break
        }
    }

    return string
}

export function DateISO() {
    let date = new Date();
    let tzo = -date.getTimezoneOffset(),
        dif = tzo >= 0 ? '+' : '-',
        pad = function(num) {
            let norm = Math.floor(Math.abs(num));
            return (norm < 10 ? '0' : '') + norm;
        }
    return date.getFullYear() +
        '-' + pad(date.getMonth() + 1) +
        '-' + pad(date.getDate()) +
        'T' + pad(date.getHours()) +
        ':' + pad(date.getMinutes()) +
        ':' + pad(date.getSeconds()) +
        dif + pad(tzo / 60) +
        ':' + pad(tzo % 60)
}

export function replaceAccent(text) {
    text = text.toLowerCase();
    text = text.replace(new RegExp('[ÁÀÂÃÅ]','gi'), 'a');
    text = text.replace(new RegExp('[ÉÈÊ]','gi'), 'e');
    text = text.replace(new RegExp('[ÍÌÎ]','gi'), 'i');
    text = text.replace(new RegExp('[ÓÒÔÕ]','gi'), 'o');
    text = text.replace(new RegExp('[ÚÙÛ]','gi'), 'u');
    text = text.replace(new RegExp('[Ç]','gi'), 'c');
    return text;
}



// WEBPACK FOOTER //
// ./src/SPRINTA/helpers/Formatter.js